import { useSearchParams } from 'react-router-dom'

import styles from './AtlasLogin.module.css'

const ERROR_MESSAGES: Record<string, string> = {
  auth_failed: 'Something went wrong while signing you in. Please try again.',
  not_authorized: "Your account isn't authorised to access this application. Please contact your account manager.",
  unavailable: 'Sign-in is temporarily unavailable. Please try again shortly.'
}

const AtlasLogin = () => {
  const [searchParams] = useSearchParams()
  const returnUrl = searchParams.get('returnUrl')
  const errorCode = searchParams.get('error')
  const errorMessage = errorCode ? ERROR_MESSAGES[errorCode] ?? ERROR_MESSAGES.auth_failed : null

  const loginHref = returnUrl
    ? `/api/atlas/auth/login?returnUrl=${encodeURIComponent(returnUrl)}`
    : '/api/atlas/auth/login'

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Sign in</h1>
        {errorMessage && <p className={styles.error}>{errorMessage}</p>}
        <a className={styles.signInButton} href={loginHref}>
          Sign in
        </a>
      </div>
    </div>
  )
}

export default AtlasLogin
